<template>
  <div>
    <div v-if="option.show">
      <div v-for="(selection, index) in option.selections" :key="index">

        <div class="car-form-item" :class="{'car-form-item-error': selection.error}" v-if="getSelectType(selection) === 'select'">
          <label class="car-label">
            {{$t(`equipments.${option.avGroup}`)}}*
          </label>
          <div class="car-select-container">
            <select :data-js="`selection__select--${option.avGroup}`"
                    @change="updateAvs"
                    v-model="selection.selectedAvs">
              <option v-if="selection.selectedAvs === null || selection.selectedAvs === undefined" :value="undefined">
                {{$t(`equipments.${option.avGroup}`)}}*
              </option>
              <option value="-1" :data-js="`selection__option--no-selection-${option.avGroup}`">
                {{$t('equipmentSelection.noEquipment')}}
              </option>
              <option v-for="avs in selection.avs"
                      :data-js="`selection__option--${avs.av.id}`"
                      :value="avs.av.id" :key="avs.av.id">
                {{ avs.av | optionTranslate }}
              </option>
            </select>
            <div class="car-select-action"></div>
          </div>
        </div>

        <div class="car-form-item" v-if="getSelectType(selection) === 'radio'">
          <div v-if="selection.avs.length === 1">
            <label class="car-label" :class="{ 'car-error': selection.error }">
              {{selection.avs[0].av | optionTranslate}}*
            </label>
            <div class="car-radio">
              <label :data-js="`selection__option--${selection.avs[0].av.id}`">
                <input type="radio"
                       :value="selection.avs[0].av.id"
                       id="radio-yes"
                       :name="getUniqueString(index, 0)"
                       @change="updateAvs(selection)"
                       v-model="selection.selectedAvs">
                <span>{{$t('yes')}}</span>
                <span :class="{'car-checked': selection.avs[0].av.id === selection.selectedAvs}" class="car-radio-checkmark"></span>
              </label>
              <label :data-js="`selection__option--no-selection-${option.avGroup}`">
                <input
                  type="radio"
                  value="-1"
                  :name="getUniqueString(index, 0)"
                  id="radio-no"
                  @change="updateAvs"
                  v-model="selection.selectedAvs">
                <span>{{$t('no')}}</span>
                <span :class="{'car-checked': '-1' === selection.selectedAvs}" class="car-radio-checkmark"></span>
              </label>
            </div>
          </div>

          <div v-else>
            <label class="car-label" :class="{ 'car-error': selection.error }">
              {{$t(`equipments.${option.avGroup}`)}}*
            </label>
            <div class="car-radio" :class="{'car-radio-column': selection.avs.length > 2}">
              <label v-if="selection.optional">
                <input type="radio"
                       value="-1"
                       :data-js="`selection__option--no-selection-2`"
                       @change="updateAvs()"
                       :name="getUniqueString(index, 0)"
                       v-model="selection.selectedAvs">
                <span>{{$t('equipmentSelection.noEquipment')}}</span>
                <span :class="{'car-checked': -1 === Number(selection.selectedAvs)}" class="car-radio-checkmark"></span>
              </label>
              <label v-for="av in selection.avs" :key="av.av.id">
                <input type="radio"
                       :value="av.av.id"
                       :id="av.av.id"
                       :data-js="`selection__option--${av.av.id}`"
                       :name="getUniqueString(index, 0)"
                       @change="updateAvs()"
                       v-model="selection.selectedAvs">
                <span>{{ av.av | optionTranslate }}</span>
                <span :class="{'car-checked': av.av.id === selection.selectedAvs}" class="car-radio-checkmark"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="car-form-item" v-if="getSelectType(selection) === 'checkbox'">
          <label class="car-label" :class="{ 'car-error': selection.error }">
            {{$t('equipmentSelection.checkboxTitle')}}*
          </label>
          <multiple-equipment-checkbox @updateAvs="updateAvs"
                                       :index="index"
                                       :option="option"
                                       :value="selection.selectedAvs"
                                       :items="selection.avs"
                                       :selection="selection"
                                       :optional="selection.optional"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleEquipmentCheckbox from '@/components/MultipleEquipmentCheckbox';
const FIELD_TYPE_CHECKBOX = 'checkbox';
const FIELD_TYPE_RADIO = 'radio';
const FIELD_TYPE_SELECT = 'select';

export default {
  name: 'EquipmentSelect',
  props: {
    option: { required: true },
    change: { required: true }
  },
  data: function() {
    return {
      serviceGroups: []
    }
  },
  methods: {
    getSelectType: function (selection) {
      const avs = selection.avs;
      let singleSelection = selection.singleSelection;
      let formFieldType = FIELD_TYPE_SELECT;

      if (!avs) return;
      // if selections.length > 1 we don't write an extra select; the hidden select we have already is used as multiple select, so we can't show it.
      if (this.option.selections.length > 1 || avs.length === 1) {
        formFieldType = FIELD_TYPE_RADIO;
      }
      if (avs.length > 1) {
        if (!singleSelection) {
          formFieldType = FIELD_TYPE_CHECKBOX;
        } else if (this.option.last) {
          formFieldType = FIELD_TYPE_RADIO;
        }
      }
      return formFieldType;
    },
    getUniqueString: function (index) {
      return `${this.option.order}-${index}`;
    },
    updateAvs: function (e) {
      this.change(this.option);
      this.$forceUpdate();
    }
  },
  components: {
    MultipleEquipmentCheckbox
  }
}
</script>
